import * as React from 'react';
import Channel from '../../domain/Channel';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import ApplicationState from '../../application/core/State';
import './Channels.css';
import getChildrenNodes from './getChildrenNodes';
import containsActiveNodeOrIsActive from './containsActiveNode';

interface StateProps {
    channels: Channel[];
}

interface Props {
    channelSelected: (channelId: number) => void;
    channelDeSelected: () => void;
    selectedNode?: number;
    color: string;
}

class Channels extends React.PureComponent<StateProps & DispatchProps & Props> {
    public render(): JSX.Element {
        return (
            <div className={`channels ${this.props.color}`}>
                <div>
                    <span className={this.props.selectedNode === -1 ? 'active root' : 'root'} onClick={this.props.channelDeSelected}>
                        All
                    </span>
                </div>
                {this.renderNodes(this.props.channels.filter((channel: Channel) => channel.parent === undefined), '')}
            </div>
        );
    }

    private renderNodes = (channels: Channel[], channelClass: string): JSX.Element => {
        return (
            <>
                {channels.map((channel: Channel) => {
                    const classes = [];
                    if (
                        this.props.selectedNode !== undefined &&
                        containsActiveNodeOrIsActive(this.props.channels, this.props.selectedNode, channel.id)
                    ) {
                        classes.push('active');
                    }
                    if (channel.parent === undefined) {
                        classes.push('root');
                    }
                    return (
                        <div key={channel.id} className={channelClass}>
                            <span className={classes.join(' ')} onClick={this.channelSelected(channel)}>
                                {channel.name}
                            </span>
                            {getChildrenNodes(this.props.channels, channel.id).length > 0 &&
                                this.props.selectedNode !== undefined &&
                                containsActiveNodeOrIsActive(this.props.channels, this.props.selectedNode, channel.id) &&
                                this.renderNodes(getChildrenNodes(this.props.channels, channel.id), 'channel-children')}
                        </div>
                    );
                })}
            </>
        );
    };

    // tslint:disable:typedef
    private channelSelected = (channel: Channel) => (): void => {
        return this.props.channelSelected(channel.id);
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    channels: state.products.channels
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Channels);



// WEBPACK FOOTER //
// ./src/view/channels/Channels.tsx